import { Box, Chip, Stack, Tab, Tabs, Typography } from '@mui/material'
import ReturnButton from 'components/Button/ReturnButton'
import useRobot from 'hooks/useRobot'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { PATH } from 'utils/constants'

import RobotDetails from './RobotDetails'
import RobotDiagnostics from './RobotDiagnostics'
import RobotMissionDetails from './RobotMissionDetails'

const RobotView = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { assetId } = useParams()
  const location = useLocation()
  const { data: robot } = useRobot()
  const [tab, setTab] = useState<'robot' | 'mission'>('robot')

  // Вкладка диагностики имеет собственный путь /asset/:assetId/diagnostic,
  // чтобы при обновлении страницы она не терялась.
  const isDiagnostics = /\/diagnostic$/.test(location.pathname)
  const activeTab: 'robot' | 'mission' | 'diagnostics' = isDiagnostics ? 'diagnostics' : tab

  const displayTab = {
    robot: <RobotDetails />,
    mission: <RobotMissionDetails />,
    diagnostics: <RobotDiagnostics />,
  }

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    if (newValue === 'diagnostics') {
      navigate(`${PATH.ROBOT_LIST}/${assetId}/diagnostic`)
      return
    }
    if (isDiagnostics) {
      navigate(`${PATH.ROBOT_LIST}/${assetId}`)
    }
    setTab(newValue as 'robot' | 'mission')
  }

  return (
    <Box
      height="100%"
      maxHeight="100%"
      paddingRight={{ xs: 0, md: 2 }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems=""
    >
      <Stack direction="row" alignItems="center" width="100%">
        <ReturnButton onClick={() => navigate(PATH.ROBOT_LIST)} />
        <Stack direction="column" height="48px" maxHeight="48px" justifyContent="space-between" mx={4}>
          <Typography variant="h5">{robot?.name}</Typography>
        </Stack>
        <Chip
          label={robot?.networkStatus === 'online' ? t('robotView.online') : t('robotView.offline')}
          variant="filled"
          color={robot?.networkStatus === 'online' ? 'primary' : 'warning'}
          size="small"
        />
      </Stack>
      <Box paddingY={2}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab value="robot" label={t('robotView.robotDetails')} />
          <Tab value="mission" label={t('robotView.missionDetails')} />
          <Tab value="diagnostics" label={t('robotView.diagnostics')} />
        </Tabs>
      </Box>
      <Box
        width="100%"
        flex={1}
        minHeight={0}
        sx={{ overflowX: 'hidden', overflowY: { xs: 'auto', md: 'hidden' } }}
      >
        {displayTab[activeTab]}
      </Box>
    </Box>
  )
}

export default RobotView
